var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Type } from './Type';
import { Int } from './Int';
var BinaryString = /** @class */ (function (_super) {
    __extends(BinaryString, _super);
    function BinaryString(length) {
        var _this = _super.call(this) || this;
        _this._length = length;
        _this._int = new Int(0);
        return _this;
    }
    BinaryString.prototype.encodeBuffer = function (value, buffer) {
        value = String(value);
        if (!this._length) {
            this._int.encodeBuffer(value.length, buffer);
        }
        for (var i = 0; i < value.length; i++) {
            this._int.encodeBuffer(value.charCodeAt(i), buffer);
        }
    };
    BinaryString.prototype.decodeBuffer = function (buffer) {
        var length = this._length || this._int.decodeBuffer(buffer);
        var codes = [];
        for (var i = 0; i < length; i++) {
            codes.push(this._int.decodeBuffer(buffer));
        }
        return String.fromCharCode.apply(String, codes);
    };
    return BinaryString;
}(Type));
export { BinaryString };
